import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "installation"
    }}>{`Installation`}</h1>
    <h3 {...{
      "id": "install-required-plugins"
    }}>{`Install Required Plugins`}</h3>
    <p><inlineCode parentName="p">{`R&B Backend Booking plugin`}</inlineCode>{` is an extension of `}<inlineCode parentName="p">{`WooCommerce`}</inlineCode>{` and `}<inlineCode parentName="p">{`WooCommerce Rental & Booking plugin`}</inlineCode>{`.
So before installing this plugin, please make sure you've installed these two required plugins.
Otherwise this plugin will not work and you'll get warning message in WordPress admin area.`}</p>
    <h4 {...{
      "id": "you-can-download-required-plugins-from-these-links"
    }}>{`You can download required plugins from these links`}</h4>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://wordpress.org/plugins/woocommerce/"
        }}>{`WooCommerce`}</a>{` By Automattic`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://codecanyon.net/item/rnb-woocommerce-rental-booking-system/14835145"
        }}>{`WooCommerce Rental & Booking`}</a>{` By RedQTeam`}</li>
    </ol>
    <h3 {...{
      "id": "install-rnb-backend-booking-plugin-from-wordpress-admin"
    }}>{`Install RnB Backend Booking Plugin from WordPress Admin:`}</h3>
    <p>{`After download the full package from CodeCanyon, you will have `}<inlineCode parentName="p">{`rnb-backend-booking.zip`}</inlineCode>{` file inside your main package. You can install it from WordPress admin.`}</p>
    <pre><code parentName="pre" {...{}}>{`1. Go to wordpress Dashboard -> plugins -> add new.
2. From here click upload plugins button, then you will find the plugin upload window.
3. Upload rnb-backend-booking.zip file from your computer then click install now button.
4. After successfully install the plugin then active it.
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      